/**
 * Note: The component should be used inside of LocalizationProvider
 */

import React from 'react';
import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  TextField,
  autocompleteClasses,
} from '@mui/material';
import moment from 'moment';
import {
  DateRange,
  DateRanges,
  DateRangesInputProvider,
  Event,
  DateRangesInputContext,
} from './DateRangesInput.context';
import { RangesList } from './RangesList';
import {
  DateRangePickerPanel,
  DateRangePickerPanelProps,
} from './DateRangePickerPanel';
import { Mode } from './DateRangesInput.context';
import { ArrowDropDown, HelpCenter } from '@mui/icons-material';
import { TableFilter } from '../table/TabIndexTableToolbar';
import { DateRangeStepper } from './DateRangeStepper';

interface DateRangesInputProps {
  disabled?: boolean;
  reply?: boolean;
  single?: boolean;
  dateRanges?: DateRanges;
  events?: Array<Event>;
  onChange?: (range: DateRange | null, ranges: DateRanges) => void;
  columns?: [number, number];
  dateRangePickerPanelProps?: DateRangePickerPanelProps;
  filters?: TableFilter[];
}

export const DateRangesInput = ({
  disabled = false,
  reply = false,
  single = false,
  dateRanges = { default: [] },
  events = [],
  onChange = () => {},
  columns = [6, 6],
  dateRangePickerPanelProps = {},
  filters,
}: DateRangesInputProps) => {
  if (dateRanges?.default?.length === 0) {
    dateRanges.default = [{ id: 0, start: null, end: null }];
  }
  return (
    <DateRangesInputProvider
      disabled={disabled}
      reply={reply}
      single={single}
      dateRanges={dateRanges}
      events={events}
      onChange={onChange}
    >
      <DateRangesInputContext.Consumer>
        {({ showInstructions }) => {
          return (
            <Grid container sx={{ position: 'relative' }}>
              {showInstructions && (
                <Grid item xs={6}>
                  <DateRangeStepper />
                </Grid>
              )}
              <Grid item xs={showInstructions ? 6 : 12}>
                <Grid
                  container
                  spacing={columns[0] + columns[1] > 12 ? 1 : 2}
                  sx={{ alignItems: 'flex-start', flexWrap: 'wrap' }}
                >
                  <Grid item xs={showInstructions ? 12 : columns[0]}>
                    <RangesList />
                  </Grid>

                  <Grid item xs={showInstructions ? 12 : columns[1]}>
                    <Grid container direction={'row'}>
                      {filters && filters.length > 0 && !reply && !disabled && (
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction="row"
                            alignItems="center"
                            alignSelf={'center'}
                            spacing={1}
                          >
                            {filters.map((f, i) => (
                              <Grid
                                item
                                // sx={{
                                //   // display: index === value ? 'block' : 'none',
                                //   flex: downMd ? 1 : 0,
                                // }}
                                key={`${i}`}
                                onClick={event => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                }}
                              >
                                <Autocomplete
                                  id={`filter-${i}`}
                                  disablePortal
                                  size="small"
                                  disableClearable
                                  options={f.options}
                                  onChange={(event, value) =>
                                    f.onChange(event, value)
                                  }
                                  value={f.defaultOption}
                                  getOptionLabel={(option: any) => {
                                    if (typeof option === 'string') {
                                      return option;
                                    } else {
                                      return (
                                        option?.label ||
                                        option?.title ||
                                        option?.name ||
                                        ''
                                      );
                                    }
                                  }}
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      size="small"
                                      label={f.label || ''}
                                      InputProps={{
                                        ...params.InputProps,
                                      }}
                                    />
                                  )}
                                  popupIcon={
                                    f.loading ? (
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          width: 24,
                                          height: 24,
                                        }}
                                      >
                                        <CircularProgress
                                          color="inherit"
                                          size={18}
                                        />
                                      </Box>
                                    ) : (
                                      <ArrowDropDown />
                                    )
                                  }
                                  fullWidth
                                  sx={{
                                    [`.${autocompleteClasses.inputRoot}`]: {
                                      [`.${autocompleteClasses.input}`]: {
                                        width: 'fit-content',
                                      },
                                    },
                                  }}
                                />
                                {/* <ControlledAutoComplete {...f} /> */}
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <DateRangePickerPanel {...dateRangePickerPanelProps} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          );
        }}
      </DateRangesInputContext.Consumer>
    </DateRangesInputProvider>
  );
};
